/* George Perfum — Aplica automáticamente el código de bienvenida al registrarse */
(() => {
  'use strict';
  const root = document.querySelector('[data-gp-welcome]');
  if (!root) return;
  const btn = root.querySelector('[data-gp-welcome-copy]');
  const code = btn && btn.dataset.code;
  if (!code) return;
  let applied = false;
  const apply = () => {
    if (applied) return;
    applied = true;
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(() => {
        try { localStorage.setItem('gpWelcomeApplied', '1'); } catch (e) {}
        const note = root.querySelector('[data-gp-auto-note]');
        if (note) note.hidden = false;
      })
      .catch(() => { applied = false; });
  };
  const check = () => { if (root.dataset.state === 'success') apply(); };
  new MutationObserver(check).observe(root, { attributes: true, attributeFilter: ['data-state'] });
  check();
})();
